import { ImageEditor } from "../imageeditor";

export class ToolBase {
  
  /**
   * @type {String}
   */
  name = "";

  /**
   * @type {Boolean}
   */
  isActive = false;

  /**
   * @type {ImageEditor}
   */
  imageEditor = null;

  /**
   * Constructeur
   * @param {String} name 
   * @param {ImageEditor} imageEditor 
   * @param {Object} opts 
   */
  constructor(imageEditor, name, opts) {
    this.name = name;
    this.imageEditor = imageEditor;
    this.registerEvents();
  }

  /**
   * Set tool as active.
   * @param {Boolean} value 
   */
  setActive(value) {
    this.isActive = value;
  }

  /**
   * Register events
   */
  registerEvents() {}

}